class KlevuTabs extends HTMLElement {
  connectedCallback() {
    this.initializeElements();
    this.initialization();
  }

  initializeElements() {
    this.elements = {
      tabs: this.querySelectorAll('[data-klevu-tabs-el="tab"]'),
    };

    this.externalElements = {
      tabPanels: document.querySelectorAll('[data-klevu-tabs-external-el="panel"]'),
    };
  }

  initialization() {
    this.hideTabsBasedOnCounts();
    this.initTabs();
  }

  hideTabsBasedOnCounts() {
    if (this.articleCount === 0) {
      this.elements.tabs[1].style.display = "none";
    }

    if (this.productCount === 0) {
      this.elements.tabs[0].style.display = "none";
    }
  }

  initTabs() {
    this.elements.tabs.forEach((tab, index) => {
      tab.setAttribute('data-index', index);
      tab.addEventListener('click', () => this.activateTab(index));
    });

    this.tabs = this.elements.tabs;
    this.panels = this.externalElements.tabPanels;
  }

  activateTab(index) {
    this.tabs.forEach(tab => tab.setAttribute('aria-selected', 'false'));
    this.panels.forEach(panel => panel.setAttribute('hidden', 'true'));

    this.tabs[index].setAttribute('aria-selected', 'true');
    this.panels[index].removeAttribute('hidden');
  }

  get articleCount() {
    return Number(this.getAttribute('data-article-count'));
  }

  get productCount() {
    return Number(this.getAttribute('data-product-count'));
  }
}

customElements.define('klevu-tabs', KlevuTabs);
